/**
 * Applies a gaussian-style distortion
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @returns {Object} Distorted point {x, y}
 */
export const gaussianDistortion = (x, y, width, height) => {
  if (x !== undefined && y !== undefined) {
    const centerX = width / 2;
    const centerY = height / 2;

    // Horizontal shift
    const distanceFromCenterX = Math.abs(x - centerX);
    const directionX = x < centerX ? -1 : 1;
    const shiftAmountX = (centerX - distanceFromCenterX) * 0.5 * directionX;

    // Vertical shift
    const distanceFromCenterY = Math.abs(y - centerY);
    const directionY = y < centerY ? -1 : 1;
    const shiftAmountY = (centerY - distanceFromCenterY) * 0.5 * directionY;

    return {
      x: x + shiftAmountX,
      y: y + shiftAmountY,
    };
  } else {
    return { x, y };
  }
};